import type { Backend } from '@freelancer/datastore/core';
import { OrderByDirection } from '@freelancer/datastore/core';
import { toNumber } from '@freelancer/utils';
import type { FeedbackCollection } from './feedback.types';

export function feedbackBackend(): Backend<FeedbackCollection> {
  return {
    defaultOrder: {
      field: 'id',
      direction: OrderByDirection.ASC,
    },
    fetch: undefined,
    push: (authUid, feedback) => {
      return {
        endpoint: `users/0.1/feedback/`,
        method: 'POST',
        payload: {
          user_id: toNumber(authUid),
          source: 'campaign',
          source_id: feedback.sourceId,
          body: feedback.body,
          rating: feedback.rating,
        },
      };
    },
    set: undefined,
    update: undefined,
    remove: undefined,
  };
}
